function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeap = function SvgHeap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.958 3h6.046v22.486h-6.046V3ZM13.86 14.244h6.046v29.514H13.86V14.244Zm19.144 18.27h-6.046V55h6.046V32.514Zm7.05-18.27H46.1v29.514h-6.046V14.244Z",
    fill: props.color,
    stroke: props.color
  }));
};
export default SvgHeap;